import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', function () {
    const elms = document.querySelectorAll('.persona-content-block .splide');

    for (const elm of elms) {
        new Splide(elm, {
            perPage: 1,
            gap: '1.6rem',
            arrows: false,
            pagination: false,
            padding: { left: 16, right: 50 },
            mediaQuery: 'min',
            breakpoints: {
                768: {
                    destroy: true
                }
            }
        }).mount();
    }
});
